import LandingPage from './landing/LandingPage';
import SEO from '@/components/SEO';

const TITLE =
  'Discloser — The Deal Engine for California Real Estate Agents';
const DESCRIPTION =
  "Discloser reads the packet, answers the buyer's worry, drafts the email between agents, and gets both sides to ready the same afternoon.";

const FAQ_LD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  '@id': 'https://www.discloser.co/#faq-seller',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'How does Discloser help listing agents close faster?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Discloser reads the full disclosure packet in about 4 minutes, surfaces every red flag with the exact page citation, and drafts buyer-side replies before the buyer asks. Listing agents skip the evening of skimming and walk into every conversation already prepared.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can Discloser pull listings directly from MLS?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes. Paste an MLS link or upload the disclosure PDF — Discloser ingests both. The AI parses the full packet (TDS, NHD, SPQ, AVID, prelim, HOA, inspections) and produces findings ranked by severity with cost estimates.',
      },
    },
    {
      '@type': 'Question',
      name: 'What happens to the disclosures I review?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can edit and archive any finding before sharing. Clients only see what you have reviewed. Cleaner handoff, less liability, and your edits are preserved if Discloser re-analyzes the packet later.',
      },
    },
  ],
};

export default function LandingColorSeller() {
  return (
    <>
      <SEO title={TITLE} description={DESCRIPTION} path="/" jsonLd={FAQ_LD} />
      <LandingPage variant="seller" />
    </>
  );
}
